import React from "react";
import { useNavigate } from "react-router-dom";
import "./dash_sidebar.css";
import ProfileHeader from "./ProfileHeader";
import { MdEdit } from "react-icons/md";

export default function DashSidebar({score}) {
  
  const navigate = useNavigate();

  return (
    <div className="cprofile-sidebar">
      
      <div className="side-links">
              <div className="dash_edit">
                  <MdEdit onClick={() => navigate("/candidate-onboarding")} style={{position:"relative", right:"2px", top:"2px"}}/>
              </div>
              
              <ProfileHeader variant="sidebar" score={score}/>
              <p onClick={() => navigate("/candidate-profile")}>Complete Profile</p>
      </div>
    </div>
  );
}
